const ModalComponent = function (show,modalId, title, z,lock,backButton,closeButton, props) {
    return {
        show: show,
        modalId : modalId,
        title : title,
        z : z,
        lock : lock,
        backButton : backButton,
        closeButton : closeButton,
        ...props,
        init() {
            window.addEventListener('hashchange', () => {
                if (window.location.hash == '#' + this.modalId) {
                    this.openModal(null, window.location.hash);
                } else {
                    this.closeModal(null, true);
                }
            });
        },
        handleTitleUpdated($event) {
            this.title = $event.detail.id == this.modalId ? $event.detail.value : this.title;
        },
        closeModal($event = null,force = false) {
            if ($event) {
                if ($event.detail?.modalId && $event.detail?.modalId === this.modalId) {
                    window.wire_modal.splice(window.wire_modal.indexOf(this.modalId), 1);
                    let next = window.wire_modal[0];
                    window.history.replaceState(null,null, next ? '#' + next : '!');
                    return this.closeModal(null, true);
                }
            }

            if (force) {
                this.show = false;
                return true;
            }


            if (!lock) {
                return this.closeModal(null,true);
            }

            return  false
        },
        openModal($event = null) {

            if ($event == null) {
                this.show = true;
                return true;
            }

            if ($event.detail?.z) {
                this.z = $event.detail.z ?? this.z;
            }

            if ($event.detail?.modalId && $event.detail?.modalId != this.modalId) {
                return false;
            }

            this.show = true;

            window.history.replaceState(null,null, '#' + this.modalId);

            return true;
        },
        focusables() {
            let selector = 'a, button, input, textarea, select, details, [tabindex]:not([tabindex=\'-1\'])'
            return [...this.$el.querySelectorAll(selector)].filter(el => ! el.hasAttribute('disabled'))
        },
        firstFocusable() { return this.focusables()[0] },
        lastFocusable() { return this.focusables().slice(-1)[0] },
        nextFocusable() { return this.focusables()[this.nextFocusableIndex()] || this.firstFocusable() },
        prevFocusable() { return this.focusables()[this.prevFocusableIndex()] || this.lastFocusable() },
        nextFocusableIndex() { return (this.focusables().indexOf(document.activeElement) + 1) % (this.focusables().length + 1) },
        prevFocusableIndex() { return Math.max(0, this.focusables().indexOf(document.activeElement)) -1 },
    }
}

export default  ModalComponent

